import * as api from '../prospectsApi';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import {
  ChangeLifecycleStep,
  getProspect,
  IProspectApiResponse,
  prospectActionCreators,
  ProspectsActionKeys
  } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IProspect } from '../prospectsInterfaces';
import { uiActionCreators } from '../../ui';

function* updateChangeLifecycleStep(action: ChangeLifecycleStep) {
  yield put(uiActionCreators.showSpinnerDialog());
  const result: IEntityWithMessages<IProspectApiResponse> = yield call(
    api.ChangeLifecycleStep,
    action.payload.id,
    action.payload.direction
  );

  if (!result.error && result.value) {
    yield put(prospectActionCreators.updateProspectFulfilled(result.value));
  }

  yield put(uiActionCreators.hideSpinnerDialog());

  if (result.messages.length > 0) {
    const prospect: IProspect = yield select(getProspect, action.payload.id);
    let title: string = `The following validation problems need to be fixed to advance ${prospect.name}:`;

    if (result.error) {
      title = 'There was a problem changing the state of this prospect.  Please rety.';
    }
    yield put(
      uiActionCreators.showMessageDialog({
        messages: result.messages,
        title
      })
    );
  }
}

export function* watchChangeLifecycleStep() {
  yield takeEvery(ProspectsActionKeys.CHANGE_LIFECYCLE_STEP, updateChangeLifecycleStep);
}
